<template>
  <div class="bg-white tools">
    <div @click="useRangingTool" class="flex jus-con-cen font-16 map-font-theme mg-b-20 cursor-pointer">测距</div>
    <div class="flex jus-con-cen font-16 map-font-theme mg-b-20 cursor-pointer">
      <a-icon type="radar-chart" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruler: null,
      show: false,
      // ruler2
    }
  },
  methods: {
    registerRangingTool(AMap, map) {
      //默认样式
      this.ruler = new AMap.RangingTool(map)

      // //自定义样式
      // var startMarkerOptions= {
      //     icon: new AMap.Icon({
      //         size: new AMap.Size(19, 31),//图标大小
      //         imageSize:new AMap.Size(19, 31),
      //         image: "//webapi.amap.com/theme/v1.3/markers/b/start.png"
      //     }),
      //     offset: new AMap.Pixel(-9, -31)
      // };
      // var endMarkerOptions = {
      //     icon: new AMap.Icon({
      //         size: new AMap.Size(19, 31),//图标大小
      //         imageSize:new AMap.Size(19, 31),
      //         image: "//webapi.amap.com/theme/v1.3/markers/b/end.png"
      //     }),
      //     offset: new AMap.Pixel(-9, -31)
      // };
      // var midMarkerOptions = {
      //     icon: new AMap.Icon({
      //         size: new AMap.Size(19, 31),//图标大小
      //         imageSize:new AMap.Size(19, 31),
      //         image: "//webapi.amap.com/theme/v1.3/markers/b/mid.png"
      //     }),
      //     offset: new AMap.Pixel(-9, -31)
      // };
      // var lineOptions = {
      //     strokeStyle: "solid",
      //     strokeColor: "#FF33FF",
      //     strokeOpacity: 1,
      //     strokeWeight: 2
      // };
      // var rulerOptions = {
      //     startMarkerOptions: startMarkerOptions,
      //     midMarkerOptions:midMarkerOptions,
      //     endMarkerOptions: endMarkerOptions,
      //     lineOptions: lineOptions
      // };
      // ruler2 = new AMap.RangingTool(map, rulerOptions);
    },
    useRangingTool() {
      if (!this.show) {
        this.ruler.turnOn()
        this.show = true
        return
      }
      this.ruler.turnOff()
      this.show = false
    },
  },
}
</script>

<style lang="less" scoped>
.tools {
  width: 60px;
  // height: 100px;
  position: absolute;
  right: 20px;
  bottom: 83px;
  padding: 30px 0 0;
}
</style>
